var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadpdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.38,15.92c-1.36-2.82-4.24-3.6-4.25-2.81,0,.48.48.1,1.4.64a5.55,5.55,0,0,1,2.12,2.5,4.82,4.82,0,1,1-9.19,2.81c-.48-2.7,1.7-5.13,4-5.74a.33.33,0,0,0-.16-.64c-2.69.63-5.21,3.37-4.75,6.53a5.72,5.72,0,1,0,10.87-3.29Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,18.68c0,.07,0,.37,0,.62a5.55,5.55,0,0,1-1.22-1.46.29.29,0,0,0-.53.24c.52,1.22,1.14,2.67,2.53,2.85.56.06.88-.33,1.14-.84a8.23,8.23,0,0,0,.64-1.39,4.32,4.32,0,0,0,.23-1,.33.33,0,0,0-.66,0,5.7,5.7,0,0,1-.52,1.08,11.34,11.34,0,0,1-.81,1.06,16.46,16.46,0,0,0,.17-2.36,7,7,0,0,0-.36-1.89,1.76,1.76,0,0,1-.06-.38.3.3,0,0,0-.23-.35c-.51-.1-.4.86-.44,1.5A8.29,8.29,0,0,0,17.9,18.68Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,5.18a9.88,9.88,0,0,0,1.5.36,10.65,10.65,0,0,0,3,0,.34.34,0,0,0,0-.67,10.14,10.14,0,0,0-3-.37,4.65,4.65,0,0,0-1.63.14C4.73,4.72,4.68,5,5,5.18Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64,9.07a.3.3,0,0,0,.49.34A17.29,17.29,0,0,1,8,9.56c2.38.06,4-.25,5.77-.34a.34.34,0,0,0,0-.67,41.44,41.44,0,0,0-6.87,0C6.46,8.62,5,8.54,4.64,9.07Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.67,13a13.55,13.55,0,0,0-5,0c-.8.13-.91.12-1,.22a.31.31,0,0,0,.14.55s.29,0,.39,0a19.27,19.27,0,0,0,5.46-.06A.34.34,0,0,0,10.67,13Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,17.32c-2.82,0-5.89-.37-8.7-.69C2.81,13,2.66,7.8,3.09,2a.92.92,0,0,1,.28-.43c1-.24,5.72-.88,6.33-.91A3.6,3.6,0,0,1,11,.77C11.42.9,12.11,0,9.68,0,9.12,0,3.85.48,3,.69s-.85.78-1.11,3.05c-.47,6.68-.51,8.42-1,10.79S0,16.86.17,17.28a.47.47,0,0,0,.39.26c2.95.23,6.51.52,9.48.45A.34.34,0,0,0,10,17.32Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,3.13c.35.34,1,.77,1.16,1.14L16,10.53a.3.3,0,0,0,.59,0c0-.54,1-5.72.52-6.75-.35-.68-.42-.45-3.87-3.35a.34.34,0,0,0-.42.53Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.42,5.07c.53,1,2.33.59,3.48.28,2-.54,1-1.53.59-1a6.05,6.05,0,0,1-3.08.2c-.2-.32,0-1.53.08-2.07.08-1.09.09-1.08-.09-1.14-.38-.16-.49.45-.64,1C11.56,3.08,11,4.16,11.42,5.07Z",
    style: {
      fill: "#000000"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M17.63,1.93A8.22,8.22,0,0,1,19,3.3l-.59,7.33c0,.38.26.54.48.22.3-.89,1.51-7.35.86-8.27A12.9,12.9,0,0,0,16.93.24a.33.33,0,1,0-.42.51Z",
    style: {
      fill: "#000000"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadpdf);
export default __webpack_public_path__ + "static/media/downloadpdf.af4ae93a6ac2783622c06dd7351645d5.svg";
export { ForwardRef as ReactComponent };